import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class RegistryService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Upsert API
     * @returns Api Created.
     * @throws ApiError
     */
    upsertApi({ orgId, projectId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/projects/{projectId}/registry/apis', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * List APIs
     * List APIs in the registry.
     * @returns ApiList OK.
     * @throws ApiError
     */
    listApis({ orgId, projectId, after, before, limit = 10, filter, sort = '-id', search, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/registry/apis', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'after': after,
                'before': before,
                'limit': limit,
                'filter': filter,
                'sort': sort,
                'search': search,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get API by path
     * @returns Api OK.
     * @throws ApiError
     */
    getApiByPath({ orgId, projectId, contentPath, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/registry/paths/{contentPath}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'contentPath': contentPath,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get API
     * @returns Api OK.
     * @throws ApiError
     */
    getApi({ orgId, projectId, apiId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/registry/apis/{apiId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'apiId': apiId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Update custom fields
     * @returns Api Updated.
     * @throws ApiError
     */
    updateApiCustomFields({ orgId, projectId, apiId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PATCH', url: '/orgs/{orgId}/projects/{projectId}/registry/apis/{apiId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'apiId': apiId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Delete API
     * @returns void
     * @throws ApiError
     */
    deleteApi({ orgId, projectId, apiId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'DELETE', url: '/orgs/{orgId}/projects/{projectId}/registry/apis/{apiId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'apiId': apiId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get OpenAPI bundle
     * @returns any OK.
     * @throws ApiError
     */
    getBundle({ orgId, projectId, apiId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/registry/apis/{apiId}/bundle.json', path: {
                'orgId': orgId,
                'projectId': projectId,
                'apiId': apiId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Create snapshot
     * @returns Snapshot Created.
     * @throws ApiError
     */
    createSnapshot({ orgId, projectId, apiId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/projects/{projectId}/registry/apis/{apiId}/snapshots', path: {
                'orgId': orgId,
                'projectId': projectId,
                'apiId': apiId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * List snapshots
     * @returns SnapshotList OK.
     * @throws ApiError
     */
    listSnapshots({ orgId, projectId, apiId, after, before, limit = 10, filter, sort = '-id', }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/registry/apis/{apiId}/snapshots', path: {
                'orgId': orgId,
                'projectId': projectId,
                'apiId': apiId,
            }, query: {
                'after': after,
                'before': before,
                'limit': limit,
                'filter': filter,
                'sort': sort,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get snapshot
     * @returns Snapshot OK.
     * @throws ApiError
     */
    getSnapshot({ orgId, projectId, apiId, snapshotId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/registry/apis/{apiId}/snapshots/{snapshotId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'apiId': apiId,
                'snapshotId': snapshotId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get snapshot bundle
     * @returns any OK.
     * @throws ApiError
     */
    getSnapshotBundle({ orgId, projectId, apiId, snapshotId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/registry/apis/{apiId}/snapshots/{snapshotId}/bundle.json', path: {
                'orgId': orgId,
                'projectId': projectId,
                'apiId': apiId,
                'snapshotId': snapshotId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Download snapshot
     * @returns void
     * @throws ApiError
     */
    downloadSnapshot({ orgId, projectId, apiId, snapshotId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/registry/apis/{apiId}/snapshots/{snapshotId}/download', path: {
                'orgId': orgId,
                'projectId': projectId,
                'apiId': apiId,
                'snapshotId': snapshotId,
            }, errors: {
                301: `Redirect to S3.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * List registry custom fields
     * List custom fields in the registry.
     * @returns CustomFieldList OK.
     * @throws ApiError
     */
    listCustomFields({ orgId, projectId, after, before, limit = 10, filter, sort = '-id', }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/registry/custom-fields', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'after': after,
                'before': before,
                'limit': limit,
                'filter': filter,
                'sort': sort,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Create a new batch removal request for APIs that do not exist in the project
     * @returns void
     * @throws ApiError
     */
    createApisBatchRemoval({ orgId, projectId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/projects/{projectId}/registry/apis-batch-removals', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=RegistryService.js.map